import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const ConstructionSolutionScreen: React.FC = () => {
  const { t } = i18n;

  return (
    <Container
      fluid
      className="screenContainer"
      style={{ backgroundColor: "var(--bg-light-color)", minHeight: "50vh" }}
    >
      <Container className="flexContainer">
        <Row className="gx-5">
          <Col className="order-2 order-lg-1 mt-5 mt-lg-0" lg={5} xs={12}>
            <div className="flexContainer" style={{ flexDirection: "row" }}>
              <Row>
                <Col xs={6}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeInLeft"
                  >
                    <Image
                      rounded
                      alt={t("Traditional Wall Assembly (7 Components)")}
                      className="mw-100"
                      src="/images/technology/Traditional_Wall_Assembly.png"
                    />
                    <figcaption>
                      {t("Traditional Wall Assembly (7 Components)")}
                    </figcaption>
                  </AnimationOnScroll>
                </Col>

                <Col xs={6}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeInRight"
                  >
                    <Image
                      rounded
                      alt={t("PakVert™ Panel (1 panel replaces 7 components)")}
                      className="mw-100"
                      src="/images/technology/PakVert_all_in_one.png"
                    />
                    <figcaption>
                      {t("PakVert™ Panel (1 panel replaces 7 components)")}
                    </figcaption>
                  </AnimationOnScroll>
                </Col>
              </Row>
            </div>
          </Col>

          <Col className="order-1 order-lg-2" lg={7} xs={12}>
            <div
              className="flexContainer installationContent"
              style={{ gap: "8px" }}
            >
              <h2>{t("_technology_screen.2.title")}</h2>
              <p>{t("_technology_screen.2.description")}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ConstructionSolutionScreen;
